/*
 * Home Messages
 *
 * This contains all the text for the Home Feature.
 */
import { defineMessages } from 'react-intl';

export const scope = 'axjorecycling.returnsystem.components';

export default defineMessages({

  general_status1: {
    id: `${scope}.general.status1`,
    defaultMessage: 'Registered.',
  },
  general_status2: {
    id: `${scope}.general.status2`,
    defaultMessage: 'In progress.',
  },
  general_status3: {
    id: `${scope}.general.status3`,
    defaultMessage: 'Booked.',
  },
  general_status4: {
    id: `${scope}.general.status4`,
    defaultMessage: 'Paid.',
  },
  general_status9: {
    id: `${scope}.general.status9`,
    defaultMessage: 'Ready.',
  },
  general_status10: {
    id: `${scope}.general.status10`,
    defaultMessage: 'Cancelled.',
  },
  general_status999: {
    id: `${scope}.general.status999`,
    defaultMessage: 'Booked.',
  },
  general_statusDefault: {
    id: `${scope}.general.statusDefault`,
    defaultMessage: 'Unknown.',
  },

  bookingInformation_returnOrder: {
    id: `${scope}.bookingInformation.returnOrder`,
    defaultMessage: 'Return order.',
  },
  bookingInformation_created: {
    id: `${scope}.bookingInformation.created`,
    defaultMessage: 'Created.',
  },
  bookingInformation_updated: {
    id: `${scope}.bookingInformation.updated`,
    defaultMessage: 'Updated.',
  },
  bookingInformation_supplierNumber: {
    id: `${scope}.bookingInformation.supplierNumber`,
    defaultMessage: 'Supplier number.',
  },
  bookingInformation_orgazationalNumber: {
    id: `${scope}.bookingInformation.orgazationalNumber`,
    defaultMessage: 'Orgazational number.',
  },
  bookingInformation_supplier: {
    id: `${scope}.bookingInformation.supplier`,
    defaultMessage: 'Supplier.',
  },
  bookingInformation_branchOffice: {
    id: `${scope}.bookingInformation.branchOffice`,
    defaultMessage: 'Branch office.',
  },
  bookingInformation_email: {
    id: `${scope}.bookingInformation.email`,
    defaultMessage: 'Email.',
  },
  bookingInformation_customerRef: {
    id: `${scope}.bookingInformation.customerRef`,
    defaultMessage: 'Customer ref.',
  },
  bookingInformation_typeOfBooking: {
    id: `${scope}.bookingInformation.typeOfBooking`,
    defaultMessage: 'Type of booking.',
  },
  bookingInformation_status: {
    id: `${scope}.bookingInformation.status`,
    defaultMessage: 'Status.',
  },
  bookingInformation_returnPoint: {
    id: `${scope}.bookingInformation.returnPoint`,
    defaultMessage: 'Return point.',
  },
  bookingInformation_returnInformation: {
    id: `${scope}.bookingInformation.returnInformation`,
    defaultMessage: 'Return information.',
  },
  bookingInformation_estimatedCashback: {
    id: `${scope}.bookingInformation.estimatedCashback`,
    defaultMessage: 'Initial estimated cashback (with freight deducted).',
  },
  bookingInformation_erpOrderNumber: {
    id: `${scope}.bookingInformation.erpOrderNumber`,
    defaultMessage: 'ERP order number.',
  },


  pickupDetails_pickupPoint: {
    id: `${scope}.pickupDetails.pickupPoint`,
    defaultMessage: 'Pickup point.',
  },
  pickupDetails_locationOnMap: {
    id: `${scope}.pickupDetails.locationOnMap`,
    defaultMessage: 'Show location om map (Opens in a new tab).',
  },
  pickupDetails_additionalServices: {
    id: `${scope}.pickupDetails.additionalServices`,
    defaultMessage: 'Additional services.',
  },
  pickupDetails_contact: {
    id: `${scope}.pickupDetails.contact`,
    defaultMessage: 'Contact.',
  },
  pickupDetails_phoneNumber: {
    id: `${scope}.pickupDetails.phoneNumber`,
    defaultMessage: 'Phone number.',
  },
  pickupDetails_craneTruck: {
    id: `${scope}.pickupDetails.craneTruck`,
    defaultMessage: 'Is a crane truck needed?.',
  },
  pickupDetails_liftingDevice: {
    id: `${scope}.pickupDetails.liftingDevice`,
    defaultMessage: 'Is there any assistance at the location (forklift etc).',
  },
  pickupDetails_pickupTime: {
    id: `${scope}.pickupDetails.pickupTime`,
    defaultMessage: 'Pick up time.',
  },
  pickupDetails_information: {
    id: `${scope}.pickupDetails.information`,
    defaultMessage: 'Information.',
  },
  pickupDetails_pickupBooked: {
    id: `${scope}.pickupDetails.pickupBooked`,
    defaultMessage: 'Picku p booked.',
  },
  pickupDetails_loadingMeters: {
    id: `${scope}.pickupDetails.loadingMeters`,
    defaultMessage: 'Transport loading meters.',
  },
  pickupDetails_weight: {
    id: `${scope}.pickupDetails.weight`,
    defaultMessage: 'Transport weight.',
  },
  pickupDetails_freight: {
    id: `${scope}.pickupDetails.freight`,
    defaultMessage: 'Freight cost (SEK).',
  },
  pickupDetails_transportCompany: {
    id: `${scope}.pickupDetails.transportCompany`,
    defaultMessage: 'Transport company.',
  },

  customerInformation_customerNumber: {
    id: `${scope}.customerInformation.customerNumber`,
    defaultMessage: 'Customer number.',
  },
    customerInformation_organizationalNumber: {
    id: `${scope}.customerInformation.organizationalNumber`,
    defaultMessage: 'Organizational number.',
  },
    customerInformation_customerName: {
    id: `${scope}.customerInformation.customerName`,
    defaultMessage: 'Customer name.',
  },
    customerInformation_status: {
    id: `${scope}.customerInformation.status`,
    defaultMessage: 'Status.',
  },
    customerInformation_contactPerson: {
    id: `${scope}.customerInformation.contactPerson`,
    defaultMessage: 'Contact person.',
  },
    customerInformation_phoneNumber: {
    id: `${scope}.customerInformation.phoneNumber`,
    defaultMessage: 'Phone number.',
  },
    customerInformation_email: {
    id: `${scope}.customerInformation.email`,
    defaultMessage: 'Email.',
  },
    customerInformation_zipCode: {
    id: `${scope}.customerInformation.zipCode`,
    defaultMessage: 'Zip code.',
  },
    customerInformation_address: {
    id: `${scope}.customerInformation.address`,
    defaultMessage: 'Address.',
  },
    customerInformation_city: {
    id: `${scope}.customerInformation.city`,
    defaultMessage: 'City.',
  },
    customerInformation_bankName: {
    id: `${scope}.customerInformation.bankName`,
    defaultMessage: 'Bank name.',
  },
    customerInformation_iban: {
    id: `${scope}.customerInformation.iban`,
    defaultMessage: 'IBAN account number.',
  },
    customerInformation_bic: {
    id: `${scope}.customerInformation.bic`,
    defaultMessage: 'BIC code.',
  },
    customerInformation_giro: {
    id: `${scope}.customerInformation.giro`,
    defaultMessage: 'Bankgiro / Plusgiro.',
  },
    customerInformation_active: {
    id: `${scope}.customerInformation.active`,
    defaultMessage: 'Active.',
  },
    customerInformation_newsletter: {
    id: `${scope}.customerInformation.newsletter`,
    defaultMessage: 'News letter.',
  },


  orderList_returnPoint: {
    id: `${scope}.orderList.returnPoint`,
    defaultMessage: 'Return point.',
  },
    orderList_transportCompany: {
    id: `${scope}.orderList.transportCompany`,
    defaultMessage: 'Transport company.',
  },
    orderList_pickupPoint: {
    id: `${scope}.orderList.pickupPoint`,
    defaultMessage: 'Pick up point.',
  },
    orderList_items: {
    id: `${scope}.orderList.items`,
    defaultMessage: 'Items.',
  },
    orderList_manufacturer: {
    id: `${scope}.orderList.manufacturer`,
    defaultMessage: 'Manufacturer.',
  },

  index_quickSearch: {
    id: `${scope}.index.quickSearch`,
    defaultMessage: 'Quick search.',
  },
  index_sortByCustomer: {
    id: `${scope}.index.sortByCustomer`,
    defaultMessage: 'Sort by customer and show customer filters.',
  },
  index_sortByTransporter: {
    id: `${scope}.index.sortByTransporter`,
    defaultMessage: 'Sort by transporter and show transporter filters.',
  },
  index_sortByReturnpoint: {
    id: `${scope}.index.sortByReturnpoint`,
    defaultMessage: 'Sort by return point and show return point filters.',
  },
  index_tabOrder: {
    id: `${scope}.index.tabOrder`,
    defaultMessage: 'Order.',
  },
  index_tabDrums: {
    id: `${scope}.index.tabDrums`,
    defaultMessage: 'Drums.',
  },
  index_tabSupplier: {
    id: `${scope}.index.tabSupplier`,
    defaultMessage: 'Supplier.',
  },
  index_btnSave: {
    id: `${scope}.index.btnSave`,
    defaultMessage: 'Save.',
  },
  index_btnCancel: {
    id: `${scope}.index.btnCancel`,
    defaultMessage: 'Cancel.',
  },

  drumList_drumqualityPrime: {
      id: `${scope}.drumList.drumQuality.drumqualityPrime`,
      defaultMessage: 'Top grade.',
    },
    drumList_drumqualityFixable: {
      id: `${scope}.drumList.drumQuality.drumqualityFixable`,
      defaultMessage: 'Repairable.',
    },
    drumList_drumqualityRejected: {
      id: `${scope}.drumList.drumQuality.drumqualityRejected`,
      defaultMessage: 'Rejected.',
    },
    drumList_typeOfDrum: {
        id: `${scope}.drumList.typeOfDrum`,
        defaultMessage: 'Type of drum.',
    },
    drumList_manufacturer: {
        id: `${scope}.drumList.manufacturer`,
        defaultMessage: 'Manufacturer.',
    },
    drumList_nrOfItems: {
        id: `${scope}.drumList.nrOfItems`,
        defaultMessage: 'Nr. of items.',
    },
    drumList_quality: {
        id: `${scope}.drumList.quality`,
        defaultMessage: 'Quality.',
    },
    drumList_totalNumberOfDrums: {
        id: `${scope}.drumList.drumListHeader.totalNumberOfDrums`,
        defaultMessage: 'Total number of drums.',
    },
    drumList_add_delete_attachments:
    {
      id: `${scope}.drumList.attachmentDialog.add_delete_attachments`,
      defaultMessage: 'Add / delete attachments.',
    },
    drumList_attachmentDialogClose:
    {
      id: `${scope}.drumList.attachmentDialog.attachmentDialogClose`,
      defaultMessage: 'Close.',
    },
    drumList_photoPopupTitle: {
      id: `${scope}.drumList.photoPopupTitle`,
      defaultMessage: 'Add/Edit photo',
    },

    drumList_btnDeliver: {
      id: `${scope}.drumList.btnDeliver`,
      defaultMessage: 'Deliver.',
    },
    drumList_btnCloseOrder: {
      id: `${scope}.drumList.btnCloseOrder`,
      defaultMessage: 'Close order.',
    },
    drumList_btnAddItem: {
      id: `${scope}.drumList.btnAddItem`,
      defaultMessage: 'Add item.',
    },
    drumList_btnAddCost: {
      id: `${scope}.drumList.btnAddCost`,
      defaultMessage: 'Add cost.',
    },
    drumList_lblAddItem: {
      id: `${scope}.drumList.lblAddItem`,
      defaultMessage: 'Add item.',
    },
    drumList_lblAddCost: {
      id: `${scope}.drumList.lblAddCost`,
      defaultMessage: 'Add cost.',
    },

});
